export default __webpack_public_path__ + "static/media/News & Announcements.b70023cc.svg";